export const formatAmount = (amount: number, language?: string | null) => amount.toLocaleString(language ?? 'en', {
    maximumFractionDigits: 9,
    roundingMode: 'ceil'
})
